import { Game } from '@denishussar/html5-game-engine';
import { GameInstance } from './game/GameInstance';

import * as WebFont from 'webfontloader';
import { SoundConstants } from './game/Constants/SoundConstants';

declare var require;
require('../fonts/fonts.css');
const gameCfg = require('../game-config.json');
const version = require('./../package.json').version;

export class Games {
    public static startGame(elementId?: string): Game {
        return new Game({
            main: GameInstance,
            version: version,
            sounds: [
                {
                    id: SoundConstants.LVL_AMBIENT,
                    path: "/sounds/Эмбиент уровня.mp3"
                },
                {
                    id: SoundConstants.WALKBY1,
                    path: "/sounds/Ходьба_1.mp3"
                },
                //ui
                {
                    id: SoundConstants.BUTTON_CLICK,
                    path: "/sounds/Нажатие на кнопку.wav"
                },
                //minigames
                {
                    id: SoundConstants.MINIGAME_ERROR,
                    path: "/sounds/Minigames/Ошибка.mp3"
                },
                {
                    id: SoundConstants.MINIGAME_COMPLETE,
                    path: "/sounds/Minigames/Завершение мини-игры.mp3"
                },
                {
                    id: SoundConstants.MINIGAME_LOOSE,
                    path: "/sounds/Minigames/Проигрыш.mp3"
                },
                    //ropes
                    {
                        id: SoundConstants.ROPES_CUTTING,
                        path: "/sounds/Minigames/Ropes/Отстегивание каната.wav"
                    },
                    //engine power up
                    {
                        id: SoundConstants.ENGINE_BUTTON,
                        path: "/sounds/Minigames/Engine/Щелчок приборной панели (кнопка).mp3"
                    },
                    {
                        id: SoundConstants.ENGINE_TUMBLER,
                        path: "/sounds/Minigames/Engine/Щелчок приборной панели (тумблер).mp3"
                    },
                    //eco chemistry
                    {
                        id: SoundConstants.ECO_GLASS,
                        path: "/sounds/Minigames/Chemistry/Звук склянки.wav"
                    },
                    {
                        id: SoundConstants.ECO_REAG_USE,
                        path: "/sounds/Minigames/Chemistry/Звук наливания реагентов.mp3"
                    },
                    {
                        id: SoundConstants.ECO_RIGHT_ANWSER,
                        path: "/sounds/Minigames/Chemistry/Звук правильного смешивания.mp3"
                    },
                    {
                        id: SoundConstants.ECO_BANG,
                        path: "/sounds/Minigames/Chemistry/Хлопок химической реакции.mp3"
                    },
                    //laser
                    {
                        id: SoundConstants.LASER_SOUND,
                        path: "/sounds/Minigames/Laser/Гул лазера.wav"
                    },
                    {
                        id: SoundConstants.LASER_MIRROR_CATCH,
                        path: "/sounds/Minigames/Laser/Захват зеркала.wav"
                    },
                    {
                        id: SoundConstants.LASER_MIRRORING,
                        path: "/sounds/Minigames/Laser/Отражение лазера.mp3"
                    },
                    {
                        id: SoundConstants.LASER_MIRROR_PUT,
                        path: "/sounds/Minigames/Laser/Установка зеркала в паз.mp3"
                    },
                    //icebraker games
                    {
                        id: SoundConstants.ICEBREAKER,
                        path: "/sounds/Minigames/Прохождение льда ледоколом.wav"
                    },
            ],
            assetsRoot: gameCfg.resourcesRoot,
            elementId: elementId || 'gamePlace',
            noWebGL: false,
            backgroundColor: 0x212b44,
            clearBeforeRender: true,
            transparent: false,
            fps: 60,
            gameId: gameCfg.gameId,
            orientations: [
                // {
                //     orientation:ScreenOrientationEnum.Portrait,
                //     orientationEnvironment: EnvironmentTypeEnum.phone
                // },
                // {
                //     orientation:ScreenOrientationEnum.PortraitAndLandscape,
                //     orientationEnvironment: EnvironmentTypeEnum.pc | EnvironmentTypeEnum.tablet
                // }
            ],
        });
    }
}

WebFont.load({
    custom: {
        families: [
            'Times New Roman',
            'Arial Black',
            'Montserrat',
            'Myriad Pro',
            'MyriadPro-Regular',
            'MyriadPro-Bold',
        ],
    },
    loading: () => Games.startGame(),
});
